module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/guaranteed-origins-mobile.51ecc9f4.jpg";